import { utils } from '@hh/global.js'
const { addToCart, reRenderShopifySections } = utils

class BundleBuilder extends HTMLElement {
  constructor() {
    super()

    this.sectionId = this.getAttribute('data-section-id')
    this.bundleSize = parseInt(this.getAttribute('data-bundle-size'), 10) || 6
    this.bundleBoxVariantId = this.getAttribute('data-bundle-box-variant-id')
    this.expandButton = this.querySelector('[data-bundle-expand]')
    this.collapseButton = this.querySelector('[data-bundle-collapse]')
    this.stickyContainer = this.querySelector('[data-bundle-sticky]')
    this.removeButtons = this.querySelectorAll('[data-bundle-quantity-remove]')
    this.addButtons = this.querySelectorAll('[data-bundle-quantity-add]')
    this.selectedVariantsContainers = this.querySelectorAll(
      '[data-bundle-contents]'
    )
    this.selectedVariantsStickyContainer = this.querySelector(
      '[data-bundle-sticky-contents]'
    )
    this.addToCartButtons = this.querySelectorAll('[data-bundle-add-to-cart]')
    this.selectionCounts = this.querySelectorAll(
      '[data-bundle-selection-count]'
    )

    this.placeholderSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg>`

    this.selectedVariants = []
  }

  connectedCallback() {
    this.removeButtons.forEach((button) => {
      button.addEventListener('click', this.handleRemoveQuantity.bind(this))
    })
    this.addButtons.forEach((button) => {
      button.addEventListener('click', this.handleAddQuantity.bind(this))
    })
    this.addToCartButtons.forEach((button) => {
      button.addEventListener('click', this.handleAddToCart.bind(this))
    })
    this.expandButton.addEventListener('click', this.handleExpand.bind(this))
    this.collapseButton.addEventListener(
      'click',
      this.handleCollapse.bind(this)
    )
    document.body.addEventListener('click', this.handleBodyClick.bind(this))
  }

  disconnectedCallback() {
    this.removeButtons.forEach((button) => {
      button.removeEventListener('click', this.handleRemoveQuantity.bind(this))
    })
    this.addButtons.forEach((button) => {
      button.removeEventListener('click', this.handleAddQuantity.bind(this))
    })

    this.addToCartButtons.forEach((button) => {
      button.removeEventListener('click', this.handleAddToCart.bind(this))
    })
    this.expandButton.removeEventListener('click', this.handleExpand.bind(this))
    this.collapseButton.removeEventListener(
      'click',
      this.handleCollapse.bind(this)
    )
    document.body.removeEventListener('click', this.handleBodyClick.bind(this))
  }

  handleBodyClick(e) {
    if (
      !this.stickyContainer.contains(e.target) &&
      this.classList.contains('bundle-builder__expanded')
    ) {
      this.handleCollapse()
    }
  }

  handleExpand() {
    this.classList.add('bundle-builder__expanded')
    document.querySelector('.js-overlay').classList.add('active')
    document.body.classList.add('scroll-lock-byob')
  }

  handleCollapse() {
    this.classList.remove('bundle-builder__expanded')
    document.querySelector('.js-overlay').classList.remove('active')
    document.body.classList.remove('scroll-lock-byob')
  }

  handleRemoveQuantity(e) {
    this.removeItem(e.currentTarget.getAttribute('data-variant-id'))

    this.updateUI()
  }

  handleAddQuantity(e) {
    if (this.selectedVariants.length >= this.bundleSize) {
      return
    }

    this.addItem(
      e.currentTarget.getAttribute('data-variant-id'),
      e.currentTarget.getAttribute('data-image-url'),
      e.currentTarget.getAttribute('data-image-alt'),
      e.currentTarget.getAttribute('data-product-title'),
      e.currentTarget.getAttribute('data-scent-notes')
    )

    this.updateUI()
  }

  async handleAddToCart() {
    this.addToCartButtons.forEach((button) => {
      button.disabled = true
    })

    // Add selections to list
    const map = new Map()
    for (const item of this.selectedVariants) {
      const { variantId } = item
      if (map.has(variantId)) {
        map.get(variantId).quantity += 1
      } else {
        map.set(variantId, { variant_id: parseInt(variantId, 10), quantity: 1 })
      }
    }
    const lineItemPropertyArray = Array.from(map.values())

    if (this.bundleBoxVariantId) {
      // Add box product to list
      // IMPORTANT: This MUST be the first item in the array for gift-wrapping line item properties to work
      lineItemPropertyArray.unshift({
        variant_id: parseInt(this.bundleBoxVariantId, 10),
        quantity: 1,
      })
    }

    const payload = {
      items: [
        {
          id: this.getAttribute('data-bundle-variant-id'),
          quantity: 1,
          properties: {
            _byob_bundle_selections: JSON.stringify(lineItemPropertyArray),
            _byob_bundle_unique_id: Math.random().toString(36).substring(2, 15),
          },
        },
      ],
    }

    try {
      reRenderShopifySections(
        await addToCart(
          payload,
          `mini-cart,header,inline-cart,${this.sectionId}`
        )
      )

      setTimeout(() => {
        document.querySelector('hh-mini-cart').open()
      }, 0)

      this.dispatchEvent(
        new CustomEvent('productAdded', {
          bubbles: true,
          composed: true,
          detail: {
            id: 'cart-notification',
          },
        })
      )
    } catch (error) {
      console.error('Error:', error)
    } finally {
      this.addToCartButtons.forEach((button) => {
        button.disabled = false
      })
    }
  }

  addItem(variantId, imageUrl, imageAlt, productTitle, scentNotes) {
    if (!variantId || !productTitle) {
      return
    }

    this.selectedVariants.push({
      variantId,
      imageUrl: imageUrl || '',
      imageAlt: imageAlt || '',
      productTitle,
      scentNotes: scentNotes || '',
    })
  }

  removeItem(variantId) {
    if (!variantId) {
      return
    }

    const foundIndex = this.selectedVariants.findIndex(
      (selection) => selection.variantId === variantId
    )
    if (foundIndex !== -1) {
      this.selectedVariants.splice(foundIndex, 1)
    }
  }

  updateUI() {
    this.updateQuantityButtons()
    this.updateBundleContents()
    this.updateAddToCart()
    this.updateSelectionCount()
  }

  updateQuantityButtons() {
    this.removeButtons.forEach((button) => {
      const variantId = button.getAttribute('data-variant-id')
      const isSelected = this.selectedVariants.some(
        (selection) => selection.variantId === variantId
      )
      button.classList[isSelected ? 'remove' : 'add']('visibility-hidden')
    })

    this.addButtons.forEach((button) => {
      const variantId = button.getAttribute('data-variant-id')
      const maxQuantity =
        parseInt(button.getAttribute('data-max-quantity'), 10) || 0
      const currentQuantity = this.selectedVariants.filter(
        (selection) => selection.variantId === variantId
      ).length
      button.disabled =
        currentQuantity >= maxQuantity ||
        this.selectedVariants.length >= this.bundleSize
      button.classList[currentQuantity > 0 ? 'add' : 'remove'](
        'bundle-builder__quantity-add--added'
      )
    })
  }

  updateBundleContents() {
    // Mobile collapsed view and desktop view
    const numEmptyItems = this.bundleSize - this.selectedVariants.length
    const markup = `
      ${this.selectedVariants
        .map(
          (selection) => `
        <li class="bundle-builder__contents-item">
          ${
            selection.imageUrl
              ? `<img src="${selection.imageUrl}" alt="${selection.imageAlt}" />`
              : this.placeholderSVG
          }
        </li>
    `
        )
        .join('')}
      ${Array(numEmptyItems)
        .fill(null)
        .map(
          () => `
        <li class="bundle-builder__contents-item bundle-builder__contents-item--empty"></li>
      `
        )
        .join('')}
    `

    this.selectedVariantsContainers.forEach((container) => {
      container.innerHTML = markup
    })

    // Mobile expanded view
    const stickyMarkup = `
      ${this.selectedVariants
        .map(
          (selection) => `
            <li class='bundle-builder__sticky-contents-item'>
              ${
                selection.imageUrl
                  ? `<img class='bundle-builder__sticky-contents-item--image' src="${selection.imageUrl}" alt="${selection.imageAlt}" />`
                  : this.placeholderSVG
              }
              <div>
                <div class='h6'>${selection.productTitle}</div>
                <div class='bundle-builder__sticky-contents-item--notes caption'>${
                  selection.scentNotes
                }</div>
              </div>
            </li>
          `
        )
        .join('')}
      ${Array(numEmptyItems)
        .fill(null)
        .map(
          () => `
            <li class='bundle-builder__sticky-contents-item'>
              <div class='bundle-builder__sticky-contents-item--placeholder'></div>
            </li>
          `
        )
        .join('')}
    `
    this.selectedVariantsStickyContainer.innerHTML = stickyMarkup
  }

  updateAddToCart() {
    this.addToCartButtons.forEach((button) => {
      button.disabled = this.selectedVariants.length !== this.bundleSize
    })
  }

  updateSelectionCount() {
    this.selectionCounts.forEach((count) => {
      count.textContent = this.selectedVariants.length
    })
  }
}

customElements.define('byo-bundle-builder', BundleBuilder)
